// src/utils/appEventHandler.js
let handler = null;

/**
 * Register a global event handler for app-level actions
 */
export const registerAppEventHandler = (callback) => {
  handler = callback;
};

/**
 * Trigger an app-level event
 */
export const triggerAppEvent = (event) => {
  if (typeof handler === "function") {
    handler(event);
  }
};
